import { Translations } from "./en"

const fr: Translations = {
  common: {
    ok: "OK !",
    cancel: "Annuler",
    back: "Retour",
  },
  welcomeScreen: {
    postscript:
      "psst  — Ce n'est probablement pas à quoi ressemble votre application. (À moins que votre designer ne vous ait donné ces écrans, dans ce cas, mettez la en prod !)",
    readyForLaunch: "Votre application, presque prête pour le lancement !",
    exciting: "(ohh, c'est excitant !)",
  },
  errorScreen: {
    title: "Quelque chose s'est mal passé !",
    friendlySubtitle:
      "C'est l'écran que vos utilisateurs verront en production lorsqu'une erreur sera lancée. Vous voudrez personnaliser ce message (situé dans `app/i18n/fr.ts`) et probablement aussi la mise en page (`app/screens/ErrorScreen`). Si vous voulez le supprimer complètement, vérifiez `app/app.tsx` pour le composant <ErrorBoundary>.",
    reset: "RÉINITIALISER L'APPLICATION",
  },
  emptyStateComponent: {
    generic: {
      heading: "Si vide... si triste",
      content:
        "Aucune donnée trouvée pour le moment. Essayez de cliquer sur le bouton pour rafraîchir ou recharger l'application.",
      button: "Essayons à nouveau",
    },
  },
  loginScreen: {
    heading: "Connexion",
    subheading: "Vous n'avez pas de compte ? ",
    link: "Inscrivez-vous",
    emailInputPlaceholder: "Email",
    passwordInputPlaceholder: "Mot de passe",
    passwordVerifyInputPlaceholder: "Verify your password",
    submitButton: "Connexion",
    errorInvalidCredentials: "Identifiants invalides",
    errorGeneric: "Quelque chose s'est mal passé",
  },
  signupScreen: {
    heading: "Inscription",
    subheading: "Vous avez déjà un compte ? ",
    link: "Connexion",
    emailInputPlaceholder: "Email",
    passwordInputPlaceholder: "Mot de passe",
    confirmPasswordInputPlaceholder: "Confirmez le mot de passe",
    submitButton: "Inscription",
    errorPasswordsDoNotMatch: "Les mots de passe ne correspondent pas",
    errorWeakPassword: "Le mot de passe est trop faible",
    errorEmailInUse: "L'email est déjà utilisé",
    errorInvalidEmail: "Email invalide",
    errorGeneric: "Quelque chose s'est mal passé",
  },
}

export default fr
